import React from "react";
import { useTranslation } from "react-i18next";
import { Popup } from "react-map-gl/mapbox";

import styles from "./coordinatesPopup.module.css";
import { Button, Typography } from "@mui/material";

const CoordinatesPopup = ({ rightClickCoords, setRightClickCoords, onAdd }) => {
  const { t } = useTranslation();
  const latitude = rightClickCoords.lat.toFixed(6);
  const longitude = rightClickCoords.lng.toFixed(6);

  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      anchor="bottom"
      onClose={() => setRightClickCoords(null)}
      closeOnClick
      className={styles.popup}
      maxWidth="600px"
    >
      <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
        {t("forms.latitude")}: {latitude}
      </Typography>

      <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
        {t("forms.longitude")}: {longitude}
      </Typography>

      <Button
        size="small"
        fullWidth
        variant="outlined"
        onClick={() => onAdd({ latitude, longitude })}
        style={{ marginTop: "10px" }}
      >
        {t("common.add")}
      </Button>
    </Popup>
  );
};

export default CoordinatesPopup;
